$('document').ready(function () {
    $('.studio-gallery__slider').slick({
        slidesToShow: 4,
        dots: false,
        centerMode: true,
        centerPadding: '160px',
        focusOnSelect: true,
        infinite: true,
        prevArrow: `<svg class="studio-gallery__prev" width="10" height="7" viewBox="0 0 10 7" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.769.252a.84.84 0 010 1.158l-4.21 4.366a.77.77 0 01-1.117 0L.232 1.41a.84.84 0 010-1.158.77.77 0 011.116 0L5 4.04 8.652.252a.77.77 0 011.117 0z"/>
                    </svg>`,
        nextArrow: `<svg class="studio-gallery__next" width="10" height="7" viewBox="0 0 10 7" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9.769.252a.84.84 0 010 1.158l-4.21 4.366a.77.77 0 01-1.117 0L.232 1.41a.84.84 0 010-1.158.77.77 0 011.116 0L5 4.04 8.652.252a.77.77 0 011.117 0z"/>
                    </svg>`,
        responsive: [
            {
                breakpoint: 1440,
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '80px',
                }
            },
            {
                breakpoint: 425,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '48px',
                }
            },
        ]
    });

    function studioMapReady() {
        let $studioAddressBlock = $('.js__studio-address'),
            studioAddress = $studioAddressBlock.data('studio-address'),
            studioName    = $studioAddressBlock.data('studio-name'),
            geocoder      = ymaps.geocode(studioAddress, {results: 1});

        geocoder.then(
            function (res) {
                let studioCoordinates = res.geoObjects.get(0).geometry.getCoordinates();
                let studioPlacemark   = new ymaps.Placemark(
                    studioCoordinates, {
                        hintContent: studioAddress,
                        balloonContentHeader: 'Студия: ' + studioName,
                        balloonContent: studioAddress,
                    }, {
                        iconLayout: 'default#image',
                        iconImageHref: '/build/site/images/circle_icon_map.png',
                        iconImageSize: [70, 77],
                    }
                );

                let studioMap  = new ymaps.Map('studio-map', {
                    center: studioCoordinates,
                    zoom: 15,
                    behaviors: ['default', 'scrollZoom'],
                    type:  'yandex#map',
                    controls: [],
                },{
                    suppressMapOpenBlock: 0,
                    maxZoom: 17
                });

                studioMap.geoObjects.add(studioPlacemark);

            }
        );
    }

    ymaps.ready(studioMapReady);
});